module.exports = __webpack_public_path__ + "static/media/fullscreen.8f5e7921.svg";